import Lottie from 'lottie-react'
import React from 'react'

import { Button } from '@/components/ui/button'

import type { FeedBackScreenTypes } from './Feedback.types'

export const Feedback = ({
  image,
  lottie,
  lottieLoop = true,
  title,
  message,
  primaryButtontext,
  secondaryButtontext,
  onClickPrimaryButton,
  onClickSecondaryButton,
  customViewStyles,
  customImageStyles,
  customLottieStyles,
  isLoading,
}: FeedBackScreenTypes) => {
  return (
    <div
      className={`flex flex-col justify-center items-center h-full w-full ${customViewStyles}`}
    >
      <div className="flex flex-col">
        <div className="flex flex-col gap-6">
          <div className="flex justify-center">
            {lottie && (
              <div className={`flex ${customLottieStyles || 'w-52 h-52'}`}>
                <Lottie
                  animationData={lottie}
                  loop={lottieLoop}
                  style={{ width: '100%', height: '100%' }}
                />
              </div>
            )}

            {image && (
              <img
                src={image}
                alt="feedbackImage"
                width={343}
                height={240}
                className={customImageStyles}
              />
            )}
          </div>

          <div className="flex justify-center">
            <h1 className="text-center text-neutralColor text-[40px] tracking-wide max-sm:text-3xl">
              {title}
            </h1>
          </div>

          <div className="flex justify-center">
            <p className="text-center text-neutralColor80 text-2xl max-sm:text-lg">
              {message}
            </p>
          </div>

          <div className="flex justify-center mt-6 gap-4 max-sm:flex-col">
            {secondaryButtontext && (
              <Button
                onClick={onClickSecondaryButton}
                variant="outline"
                size="lg"
                isLoading={isLoading}
                className="rounded-full"
              >
                {secondaryButtontext}
              </Button>
            )}

            {primaryButtontext && (
              <Button
                onClick={onClickPrimaryButton}
                variant="default"
                size="lg"
                isLoading={isLoading}
                className="rounded-full"
              >
                {primaryButtontext}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
